import {
  PRODUCT_SOURCE_REQUEST,
  PRODUCT_SOURCE_SUCCESS,
  PRODUCT_SOURCE_FAILED,
  PRODUCT_SOURCE_CREATE,
  PRODUCT_SOURCE_CREATE_SUCCESS,
  PRODUCT_SOURCE_CREATE_FAILED,
  PRODUCT_SOURCE_DELETE,
  PRODUCT_SOURCE_DELETE_SUCCESS,
  PRODUCT_SOURCE_DELETE_FAILED,
  PRODUCT_SOURCE_EDIT,
  PRODUCT_SOURCE_EDIT_SUCCESS,
  PRODUCT_SOURCE_EDIT_FAILED,
  PRODUCT_SOURCE_STATE_CHANGE,
} from "../../../_utils/constants/ProductCatalog";


const initialState = {
  valueList: [],
  isLoading: false,
  isSuccess: false,
  isCreated: false,
  isDeleted: false,
  isEdited: false,
  errors: {},
};

const ProductSourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_SOURCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        errors: {}
      }
    case PRODUCT_SOURCE_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        valueList: decryptedData.result,
        isLoading: false,
        isSuccess: true,
        errors: {}
      }
    case PRODUCT_SOURCE_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        errors: action.payload
      }
    case PRODUCT_SOURCE_CREATE:
      return {
        ...state,
        isLoading: true,
        isCreated: false,
        errors: {}
      }
    case PRODUCT_SOURCE_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isCreated: true,
        errors: {}
      }
    case PRODUCT_SOURCE_CREATE_FAILED:
      return {
        ...state,
        isLoading: false,
        isCreated: false,
        errors: action.payload
      }

    case PRODUCT_SOURCE_DELETE:
      return {
        ...state,
        isLoading: true,
        isDeleted: false,
        errors: {}
      }
    case PRODUCT_SOURCE_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDeleted: true,
        errors: {}
      }
    case PRODUCT_SOURCE_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        isDeleted: false,
        errors: action.payload
      }
    case PRODUCT_SOURCE_EDIT:
      return {
        ...state,
        isLoading: true,
        isEdited: false,
        errors: {}
      }
    case PRODUCT_SOURCE_EDIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEdited: true,
        errors: {}
      }
    case PRODUCT_SOURCE_EDIT_FAILED:
      return {
        ...state,
        isLoading: false,
        isEdited: false,
        errors: action.error
      }

    case PRODUCT_SOURCE_STATE_CHANGE:
      return {
        ...state,
        isCreated: false,
        isDeleted: false,
        isEdited: false,
      }
  };
  return state;
};


export default ProductSourceReducer;